export class NeoCargo {
  constructor(
      public descripcion: String,
      public monto: Number,
      public idTipoCargo_NeoTipoCargo: Number,
      public idParametrizacionCondicion: Number
  ) {}
}
